const state = {
  profile: null,
  token: null
}

const getters = {
  isLogined: (state) => (state.profile),
  profile: (state) => (state.profile),
  name: (state) => ((state.profile || {}).name),
  avatar: (state) => ((state.profile || {}).photo),
  token: (state) => (state.token)
}

const mutations = {
  update: (state, data) => {
    data = data || {}
    state.profile = data.profile
    state.token = data.token
  }
}

const actions = {
  signIn: ({ commit }, data) => commit('update', data),
  signOut: ({ commit, dispatch }) => {
    commit('update', null)
    dispatch('ads/reset', {}, { root: true })
    window.localStorage.removeItem('vuex')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
